import { createAsyncThunk } from '@reduxjs/toolkit';

import { ContentNugget } from '@backrs_ui/common-ui';

import { fetchWrapper as fetch } from '@backrs_ui/grow-ui/src/utils/fetch/fetchWrapper';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export const fetchContentNuggetsByCompetencySlugs = createAsyncThunk(
  'contentNugget/fetchContentNuggetsByCompetencySlugs',
  async (params: { competency_slugs: string[] }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${ENVIRONMENT_URL}/content-nugget/by-competency-slugs?competency_slugs=${params.competency_slugs.join(',')}`,
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as ContentNugget[];
    } catch (error) {
      return rejectWithValue(
        `Failed to fetch content nuggets by competency slugs with error: ${error}`,
      );
    }
  },
);
